<template>
    <div class="gn" style=" height: 60px !important;top: 90px;">
        <el-menu :popper-append-to-body="false" menu-trigger="hover" active-text-color="#1E7FE5" :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="1">首页</el-menu-item>
            <div class="shu" style="margin-right: 40px;"></div>
            <el-submenu index="2">
                <template slot="title" style="display: flex;align-items: center;">
                    <div id="hdbm" :class="activeIndex == 2?'ac':'an'" @click="toac">活动报名 <i style="position: relative;top: -2px;" class="el-icon-caret-bottom"></i></div>
                </template>
                <el-menu-item :index="`${index+10}`" v-for="item,index in list" v-text="item.name"></el-menu-item>
            </el-submenu>
            <div class="shu" style="margin-left: 40px;"></div>
            <el-menu-item index="3">在线学习</el-menu-item>
            <div class="shu"></div>
            <el-menu-item index="4">求职招聘</a></el-menu-item>
            <div class="shu"></div>
            <el-menu-item index="5">导师陪跑</a></el-menu-item>
            <div class="shu"></div>
            <el-menu-item index="6">职业认证</a></el-menu-item>
            <div class="shu"></div>
            <el-menu-item index="7">学历提升</a></el-menu-item>
            <div class="shu"></div>
            <el-menu-item index="8">图书购买</a></el-menu-item>
            <div class="shu"></div>
            <el-menu-item index="9">服务采购</a></el-menu-item>
        </el-menu>
    </div>

</template>

<script>
    import {
        getActivityCates
    } from "@/api/index.js"
    export default {
        name: 'Gns',
        data() {
            return {
                activeIndex: "1",
                list: []
            }
        },
        created() {
            let that = this
            getActivityCates().then((res) => {
                console.log(res)
                if (res.code == 1) {
                    that.list = res.data.icon_nav[0]
                }
            })
        },
        methods: {
           toac(){
               this.activeIndex = 2
              this.$router.push({
                  path: '/acindex'
              })
           },
            handleSelect(e) {
                let that = this
                that.activeIndex = e
                console.log(e)
                if (e > 9) {
                    that.$router.push({
                        path: '/signList', // 写路由path
                        query: {
                            id: that.list[(e - 10)].id,
                            name: that.list[(e - 10)].name
                        }
                    })
                }
                if (e == 1) {
                    if (this.$route.path === '/') return
                    // 路由跳转
                    this.$router.push('/')
                }

                if (e == 3) {
                    if (this.$route.path === '/Live') return
                    this.$router.push('/Live')
                }
                
                if (e == 4) {
                    if (this.$route.path === '/Recruitment') return
                    this.$router.push('/Recruitment')
                }

                if (e == 5) {
                    if (this.$route.path === '/coach') return
                    this.$router.push('/coach')
                }
                if (e == 6) {
                    if (this.$route.path === '/certification') return
                    this.$router.push('/certification')
                }

                if (e == 7) {
                    if (this.$route.path === '/education') return
                    this.$router.push('/education')
                }
                
                if (e == 8) {
                    if (this.$route.path === '/books') return
                    this.$router.push('/books')
                }
                
                if (e == 9) {
                    if (this.$route.path === '/serviceIndex') return
                    this.$router.push('/serviceIndex')
                }
                
                if (e == 2) {
                    if (this.$route.path === '/acindex') return
                    this.$router.push('/acindex')
                }
            }
        }
    }
</script>

<style scoped>
    #hdbm:hover .el-icon-caret-bottom{
        color: rgb(30, 127, 229) !important;
        transform: rotate(180deg);
        transition: 0.3s;
    }
    #hdbm .el-icon-caret-bottom{
       
        transform: rotate(0deg);
        transition: 0.3s;
    }
    .an{
    }
    .ac{
        color: rgb(30, 127, 229);
        border-bottom: 2px solid rgb(30, 127, 229);
    }
    .el-menu--horizontal>>>.el-submenu .el-submenu__icon-arrow{
        display: none !important;
    }
    .gn .el-menu--horizontal>.el-submenu .el-submenu__title {
        padding: 0 !important;
    }
    
    .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title{
        height: 52px !important;
        border-bottom: 2px dashed #d9d9d9 !important;
        text-align: center !important;
        line-height: 52px !important;
    }

    .gn .el-menu--horizontal>.el-menu-item {
        padding: 0 60px !important;
    }
    

    .shu {
        width: 1px;
        height: 12px;
        background: #E2E2E2;
        transform: rotate(10deg);
    }

    .menuitem {}

    .el-menu-demo {
        display: flex;
        align-items: center;
        justify-content: center;
        background: transparent !important;
    }

    .gn {
        margin: 0 auto;
        position: absolute;
        left: 0;
        top: 90px;
        background: #fff !important;
        width: 100vw;
        z-index: 110;
       
    }
    .el-menu--horizontal>.el-menu-item.is-active{
        border-bottom-color: rgb(30, 127, 229) !important;
    }
    
    .el-menu--horizontal>.el-menu-item.is-active::after {
      content: "";
      position: absolute;
      left: 25%; /* (100-50)/2 居中 */
      bottom: 0;
      width: 50%;
      height: 2px; /* 边框粗细 */
      background: #409EFF;
    }
    
</style>